import ComicCard from '@/components/base/ComicCard';
import { comics, latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  const comicMap = new Map(comics.map((c) => [c.id, c]));

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-time-line text-lg text-accent-500"></i>
            </div>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">最新更新</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5 mb-8">
          {latestUpdates.slice(0, 10).map((update) => {
            const comic = comicMap.get(update.comicId);
            if (!comic) return null;
            return (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                author={comic.author}
                rating={comic.rating}
                status={comic.status}
                updateChapter={update.chapter}
              />
            );
          })}
        </div>

        <div className="bg-background-100 rounded-lg p-4 md:p-5">
          <h3 className="text-sm font-semibold text-foreground-900 mb-3">更新日志</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {latestUpdates.map((update) => (
              <a
                key={`${update.comicId}-${update.chapter}`}
                href={`/comic/${update.comicId}`}
                className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-background-200/70 transition-colors cursor-pointer group"
              >
                <div className="flex items-center gap-2 min-w-0">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
                  <span className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {update.title}
                  </span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap flex-shrink-0">
                    {update.chapter}
                  </span>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0 ml-3">
                  {update.time}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}